import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import "../../../assets/css/createevent/CreateEvent.css"
import { useState } from "react";

const EditMyEvent = () => {
    const EventId = useParams()?.id;

    const [tabValue, setTabValue] = useState("Basic-Information");


    return (
        <>

            <Row>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Edit Event</h4>

                            <button className="btn" style={{ padding: "8px", border: "1px solid #6a73fa", color: "#6a73fa" }} onClick={() => window.history.back()}>Back</button>
                        </div>
                        <div className="card-body">


                            <div className="row mb-5 mt-2">
                                <div className="tab-container">
                                    <button
                                        className={`${tabValue === "Basic-Information" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Basic-Information")}
                                    >
                                        Basic Information
                                    </button>
                                    <button
                                        className={`${tabValue === "Packages" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Packages")}
                                    >
                                        Packages
                                    </button>
                                    <button
                                        className={`${tabValue === "Media-Hub" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Media-Hub")}
                                    >
                                        Media Hub
                                    </button>
                                    <button
                                        className={`${tabValue === "Speaker-List" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Speaker-List")}
                                    >
                                        Speaker List
                                    </button>
                                    <button
                                        className={`${tabValue === "Domain-Info" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Domain-Info")}
                                    >
                                        Domain Info
                                    </button>
                                    <button
                                        className={`${tabValue === "Social-Media" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Social-Media")}
                                    >
                                        Social Media
                                    </button>
                                </div>


                                <div className="row mt-5">


                                    {tabValue == "Basic-Information" ? (
                                        <div className="">

                                        </div>
                                    ) : tabValue == "Packages" ? (
                                        <div className="">
                                        </div>
                                    ) : tabValue == "Media-Hub" ? (
                                        <div className="">
                                        </div>
                                    ) : tabValue == "Speaker-List" ? (
                                        <div className="">
                                        </div>
                                    ) : tabValue == "Domain-Info" ? (
                                        <div className="">
                                        </div>
                                    ) : tabValue == "Social-Media" ? (
                                        <div className="">
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}
export default EditMyEvent;